module.exports = __webpack_public_path__ + "static/media/section_2_C.90b4197d.png";